import {
    IAiControllerServiceDelegates,
    IAiController,
} from '@src/slide/application/service/ai-controller/core/base/ai-controller.interface';
import {
    IAiControllerInjectable,
} from '@src/slide/application/service/ai-controller/inject/ai-controller-Injectable.interface';
import { IAiService } from '@src/slide/application/service/ai/core/base/ai-service.interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';
import * as aiReporter from './report';

/**
 * 在AIService加载之前，检测ai是否可用，显示ai引导，获取AIService等等
 */
export default class BaseAiController implements IAiController {
    protected services: IAiControllerServiceDelegates;

    public constructor(protected inject: IAiControllerInjectable) {
        aiReporter.reportExposure();
        SlideDataServices.SDKDataServices.EventManager.promise().then(({ mutationEvents }) => {
            const off = mutationEvents.onSubmitMutations(() => {
                aiReporter.reportEdit();
                off();
            });
        });

        eventBus.on(EventKeys.START_EXPORT, () => {
            aiReporter.reportExport();
        });
    }

    public setServiceDelegates(services: IAiControllerServiceDelegates) {
        this.services = {
            ...this.services,
            ...services,
        };
    }

    public checkIsSupportAI(): boolean {
        return this.inject.checkIsSupportAI();
    }

    public checkIsSupportAIEdit(): boolean {
        return this.inject.checkIsSupportAI() && !this.inject.isPreviewOnly();
    }

    public async loadAIModule(): Promise<IAiService> {
        return this.services.aiService.promise();
    }

    public showAIGuide(container: HTMLElement) {
        // 子类重写
    }
}
